import { render } from "./App.vue?vue&type=template&id=05234f6a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=05234f6a&lang=css"
script.render = render

export default script